"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { MapPin, Phone, Mail, Linkedin, Youtube, ArrowUp } from "lucide-react";
const quickLinks = [{
  label: "The Collection",
  to: "/CollectionPage"
}, {
  label: "The Blueprint",
  to: "How it works"
}, {
  label: "Frequently Asked Questions",
  to: "FAQ"
}];
const supportLinks = [{
  label: "Start Your Brand",
  to: "/StartYourBrandPage"
}, {
  label: "Customization Guide",
  to: "/CollectionPage"
}, {
  label: "Manufacturing Process",
  to: "/BlueprintPage"
}];
const socialLinks = [{
  icon: Linkedin,
  to: "#",
  label: "LinkedIn"
}];
export default function FooterInformation() {
  const scrollToTop = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };
  return <footer data-section-id="121064" id="footer" className="bg-background text-foreground pt-16 pb-16 border-t border-border">
      <div className="container mx-auto px-4 md:px-6 bg-card rounded-2xl p-8 md:p-12 border border-border">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {}
          <div className="flex flex-col items-start">
            <Link to="/HomePage" className="mb-6 inline-block">
              <img src="https://watches-wholesaler.com/wp-content/uploads/2026/05/63f46fd1-ab03-4dc3-8a17-5ab2bf590968.png" alt="HTIMES" className="h-7 w-auto object-contain" />
            </Link>
            <ul className="space-y-4 text-secondary text-sm font-sans">
              <li className="flex items-start gap-3">
                <MapPin className="size-5 shrink-0 text-foreground mt-0.5" />
                <span></span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="size-5 shrink-0 text-foreground" />
                <span>+86 139 258 26801</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="size-5 shrink-0 text-foreground" />
                <span>info@watches-wholesaler.com</span>
              </li>
            </ul>
          </div>

          {}
          <div>
            
            <ul className="space-y-3">
              {quickLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to={link.to} className="text-sm font-sans text-foreground hover:text-primary transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="text-sm font-sans font-bold mb-6 text-foreground uppercase tracking-widest">
              Services
            </h3>
            <ul className="space-y-3">
              {supportLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to={link.to} className="text-sm font-sans text-foreground hover:text-primary transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="text-sm font-sans font-bold mb-6 text-foreground uppercase tracking-widest">
              Connect
            </h3>
            
          </div>
        </div>

        <Separator className="mb-8 bg-border" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs font-mono text-secondary uppercase tracking-wider">
            &copy; 2026 HTIMES. <span className="text-foreground font-medium">Low MOQ Private Label Watch Service</span>.
          </p>
          <Button variant="default" size="sm" onClick={scrollToTop} className="gap-2 rounded-lg font-mono text-xs uppercase tracking-tighter">
            Back to Top
            <ArrowUp className="size-4" />
          </Button>
        </div>
      </div>
    </footer>;
}